<template>
<div :class="[$style.h100, 'lnb-nav']">
  <div class="search">
    <w-search-field @search="filterTree"/>
  </div>
  <el-radio-group v-if="disablePhysicalTreeFlag === false"  class="search tree-type-radio" style="margin-top:15px; width:100%;" v-model="activeTreeType">
    <el-radio-button style="width:50%;" :label="treeType.LOGICAL"><span>논리 그룹</span></el-radio-button>
    <el-radio-button style="width:50%;" :label="treeType.PHYSICAL"><span>물리 그룹</span></el-radio-button>
  </el-radio-group>
  <div v-if="disablePhysicalTreeFlag === false" style="margin-top:15px; height:calc(100% - 135px); width:100%;" v-loading="logicalTreeLoading || physicalTreeLoading">
    <div v-show="activeTreeType === treeType.LOGICAL" style="height:100%;" v-loading="logicalTreeLoading">
      <el-scrollbar>
        <w-logical-tree v-if="dynamicTreeFlag === false" style="padding-left:18px;" ref="logicalTree" :keyword="keyword"
          @dragTreeNode="onDragTreeNode" @dragendTreeNode="onDragEndTreeNode" @clickNode="onClickTreeNode"/>
        <w-dynamic-logical-tree v-if="dynamicTreeFlag === true" style="padding-left:18px;" ref="logicalTree"
          @dragTreeNode="onDragTreeNode" @dragendTreeNode="onDragEndTreeNode" @clickNode="onClickTreeNode" @show-message="onShowMessage"/>
      </el-scrollbar>
    </div>
    <div v-show="activeTreeType === treeType.PHYSICAL" style="height:100%;" v-loading="physicalTreeLoading">
      <el-scrollbar>
        <w-physical-tree v-if="dynamicTreeFlag === false" style="padding-left:18px;" ref="physicalTree" :keyword="keyword"
          @dragTreeNode="onDragTreeNode" @dragendTreeNode="onDragEndTreeNode" @clickNode="onClickTreeNode"/>
        <w-dynamic-physical-tree v-if="dynamicTreeFlag === true" style="padding-left:18px;" ref="physicalTree"
          @dragTreeNode="onDragTreeNode" @dragendTreeNode="onDragEndTreeNode" @clickNode="onClickTreeNode" @show-message="onShowMessage"/>
      </el-scrollbar>
    </div>
  </div>
  <div v-else style="margin-top:15px; height:calc(100% - 135px); width:100%;" v-loading="physicalTreeLoading">
    <el-scrollbar>
      <w-logical-tree v-if="dynamicTreeFlag === false" style="padding-left:18px;" ref="logicalTree" :keyword="keyword"
        @dragTreeNode="onDragTreeNode" @dragendTreeNode="onDragEndTreeNode" @clickNode="onClickTreeNode"/>
      <w-dynamic-logical-tree v-if="dynamicTreeFlag === true" style="padding-left:18px;" ref="logicalTree"
        @dragTreeNode="onDragTreeNode" @dragendTreeNode="onDragEndTreeNode" @clickNode="onClickTreeNode" @show-message="onShowMessage"/>
    </el-scrollbar>
  </div>
</div>
</template>

<script>
import isNil from 'lodash/isNil';
import MsgUtil from '@/utils/message';
import WTreeSplitterTemplate from '@/components/template/TreeSplitterTemplate';
import WSearchField from '@/components/form/SearchField';
import { treeType } from '@/constants/tree';
import SearchLimitMixin from '@/mixins/tree/search-limit';
import WLogicalTree from './LogicalTree';
import WPhysicalTree from './PhysicalTree';
import WDynamicLogicalTree from './DynamicLogicalTree';
import WDynamicPhysicalTree from './DynamicPhysicalTree';

export default {
  name: 'WChartAnalysisTree',
  mixins: [SearchLimitMixin],
  components: {
    WTreeSplitterTemplate,
    WSearchField,
    WLogicalTree,
    WPhysicalTree,
    WDynamicLogicalTree,
    WDynamicPhysicalTree,
  },
  data() {
    return {
      treeType,
      keyword: null,
      logicalTreeLoading: false,
      activeTreeType: treeType.LOGICAL,
    };
  },
  computed: {
    dynamicTreeFlag() {
      return this.$store.state.tree.dynamicTreeFlag;
    },
    disablePhysicalTreeFlag() {
      return this.$store.state.tree.disablePhysicalTreeFlag;
    },
    physicalTreeLoading() {
      return this.$store.state.tree.physicalTreeLoading;
    },
  },
  methods: {
    onDragTreeNode(node) {
      this.$emit('dragTreeNode', node);
    },
    onDragEndTreeNode() {
      this.$emit('dragendTreeNode');
    },
    onClickTreeNode(data, node) {
      this.$emit('clickNode', data, node);
    },
    /**
     * 검색 키워드 기준으로 트리 데이터를 필터링한다.
     * @author Ju
     * @param  {String} value
     */
    filterTree(value) {
      const checkSearchable = this.checkSearchableKeyword(value);
      this.messageInfo = null;
      if (checkSearchable.searchable) {
        this.$refs.logicalTree.filterTree(value);
        if (this.disablePhysicalTreeFlag === false) {
          this.$refs.physicalTree.filterTree(value);
        }
      } else if (!isNil(checkSearchable.message)) {
        this.$message(MsgUtil.getCustomMsgData(checkSearchable.message));
      }
    },
    /**
     * 메시지 제공 이벤트 핸들러
     * @author Ju
     * @param  {String} message
     */
    onShowMessage(message) {
      if (isNil(this.messageInfo) || this.messageInfo.message !== message || new Date().getTime() - this.messageInfo.checkDatetime >= 3000) {
        const infoMessage = this.getSearchInfoMessage(message);
        this.$message(MsgUtil.getCustomMsgData(isNil(infoMessage) ? message : infoMessage));
        this.messageInfo = {
          message,
          checkDatetime: new Date().getTime(),
        };
      }
    },
  },
};
</script>

<style module>
.h100 {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/chart/components/tree/index.vue